'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (series, layout, metaData, dashboard) {
    if (layout.hideSubtitle) {
        return null;
    }

    var subtitle = void 0;

    // DHIS2-578: allow for optional custom subtitle
    if ((0, _isString2.default)(layout.subtitle)) {
        subtitle = { text: layout.subtitle };
    } else {
        var filterTitle = (0, _getFilterTitle2.default)(layout.filters, metaData);

        switch (layout.type) {
            case _.CHART_TYPE_PIE:
            case _.CHART_TYPE_GAUGE:
                subtitle = (0, _gauge2.default)(series, layout, dashboard, filterTitle);
                break;
            default:
                subtitle = getDefault(layout, dashboard, filterTitle);
        }
    }

    return subtitle ? _extends({}, DEFAULT_SUBTITLE, dashboard ? DASHBOARD_SUBTITLE : undefined, subtitle) : subtitle;
};

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _gauge = require('./gauge');

var _gauge2 = _interopRequireDefault(_gauge);

var _getFilterTitle = require('../getFilterTitle');

var _getFilterTitle2 = _interopRequireDefault(_getFilterTitle);

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_SUBTITLE = {
    style: {
        // DHIS2-578: dynamically truncate subtitle when it's taking more than 1 line
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',

        fontSize: '14px',
        color: '#555',
        textShadow: '0 0 #999'
    }
};

var DASHBOARD_SUBTITLE = {
    style: {
        // DHIS2-578: dynamically truncate subtitle when it's taking more than 1 line
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',

        fontSize: '12px'
    }
};

function getDefault(layout, dashboard, filterTitle) {
    return {
        text: dashboard || (0, _isString2.default)(layout.title) ? filterTitle : undefined
    };
}
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/subtitle/index.js
 ** module id = 210
 ** module chunks = 0 1
 **/